"use strict";
// Setup event-listeners for checkbox-cards and radio-cards
window.addEventListener('DOMContentLoaded', () => {
    document
        .querySelectorAll('.checkbox-card input[type="checkbox"],.radio-card input[type="radio"]')
        .forEach(elUntyped => {
        const el = elUntyped;
        if (el.checked) {
            el.closest('.control')?.classList.add('checked');
        }
        else {
            el.closest('.control')?.classList.remove('checked');
        }
    });
    document.querySelectorAll('.checkbox-card input[type="checkbox"]').forEach(el => {
        el.addEventListener('change', event => {
            // @ts-expect-error - TS doesn't know about the closest method
            event.target?.closest('.control').classList.toggle('checked');
        });
    });
    document.querySelectorAll('.checkbox-card').forEach(el => {
        el.addEventListener('click', setCheckboxCards);
    });
    document.querySelectorAll('.radio-card').forEach(el => {
        el.addEventListener('click', setRadioCards);
    });
});
function setCheckboxCards(event) {
    const blacklist = ['input', 'label', 'textarea', 'select', 'button', 'a'];
    const isIgnored = event.composedPath().filter(el => {
        return blacklist.includes(String(el.tagName).toLowerCase());
    });
    // @ts-expect-error - Too lazy to fix this
    const el = this;
    if (!isIgnored.length) {
        const thisInputEl = el.querySelector('input[type="checkbox"]');
        el.classList.toggle('checked');
        if (!thisInputEl)
            return;
        thisInputEl.checked = !thisInputEl.checked;
    }
}
function setRadioCards(event) {
    const blacklist = ['input', 'textarea', 'select', 'button', 'a'];
    const isInput = event.composedPath().filter(el => {
        return blacklist.includes(String(el.tagName).toLowerCase()) && el.type !== 'radio';
    });
    // @ts-expect-error - Too lazy to fix this
    const el = this;
    if (!isInput.length) {
        let thisInputEl;
        if (el.type === 'radio') {
            thisInputEl = el;
        }
        else {
            thisInputEl = el.querySelector('input[type="radio"]');
        }
        document.querySelectorAll(`input[type="radio"][name="${thisInputEl.name}"]`).forEach(subElUntyped => {
            const subEl = subElUntyped;
            if (el == thisInputEl) {
                subEl.checked = true;
                subEl.closest('.control')?.classList.add('checked');
            }
            else {
                subEl.checked = false;
                subEl.closest('.control')?.classList.remove('checked');
            }
        });
    }
}
